var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schoolWarp" },
    [
      _c("ZhjySerach", {
        attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
        on: {
          "update:modelData": function ($event) {
            _vm.modelData = $event
          },
          "update:model-data": function ($event) {
            _vm.modelData = $event
          },
          search: _vm.search,
        },
      }),
      _vm._v(" "),
      _c("FunBtn", {
        attrs: {
          defaultColumn: _vm.defaultColumn,
          isShowSelectChange: true,
          funBtns: _vm.funBtns,
        },
        on: {
          add: _vm.add,
          deleteById: _vm.deleteById,
          morePut: _vm.morePut,
          moreNoPut: _vm.moreNoPut,
        },
      }),
      _vm._v(" "),
      _c("ZhjyTable", {
        attrs: {
          minWidth: _vm.minWidth,
          tableData: _vm.listData,
          columList: _vm.defaultColumn,
          isShowSelection: true,
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          formatters: _vm.formatters,
          options: _vm.options,
          sort: _vm.sort,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleSelectionChange: _vm.handleSelectionChange,
          edit: _vm.edit,
          deleteById: _vm.deleteById,
          toPut: _vm.toPut,
          noputnaniu: _vm.noputnaniu,
          putnaniu: _vm.putnaniu,
          distribution: _vm.distribution,
          viewAdmin: _vm.viewAdmin,
          sortChange: _vm.sortChange,
          "update:sort": function ($event) {
            _vm.sort = $event
          },
        },
      }),
      _vm._v(" "),
      _c("ZhjyPagination", {
        attrs: {
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          total: _vm.totalData,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleCurrentChange: _vm.handleCurrentChange,
          handleSizeChange: _vm.handleSizeChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }